import React, { Component } from 'react';
// import logo from './/logo.svg';
import './App.css';
import Home from './Components/Home/Home';
import HeaderTop from './Components/HeaderTop/HeaderTop';
import HeaderBottom from './Components/HeaderBottom/HeaderBottom';
import HeaderSlider from './Components/HeaderSlider/HeaderSlider';
import NewArrive from './Components/NewArrive/NewArrive';
import PopularBrands from './Components/PopularBrands/PopularBrands';
import NewCollection from './Components/NewCollection/NewCollection';
import FinalSale from './Components/FinalSale/FinalSale';
import Event from './Components/Event/Event';
import Footer from './Components/Footer/Footer';
import Newsletter from './Components/Newsletter/Newsletter';
import Login from "./Components/Login/Login";
import ExpandCategoris from "./Components/ExpandCategoris/ExpandCategoris";
import Filter from "./Components/Filter/Filter";
import Paginations from "./Components/Paginations/Paginations";
import Breadcrumbing from "./Components/Breadcrumbing/Breadcrumbing";
import Wishlist from "./Components/Wishlist/Wishlist";
import Register from "./Components/Register/Register";
import Signwith from "./Components/Signwith/Signwith";
import CartEmpty from "./Components/CartEmpty/CartEmpty";
import WishlistEmpty from "./Components/WishlistEmpty/WishlistEmpty";
import ForgitPassword from "./Components/ForgitPassword/ForgitPassword";
import EmailSent from "./Components/EmailSent/EmailSent";
import Checkout from "./Components/Checkout/Checkout";
import Cart from "./Components/Cart/Cart";
import SingleProducts from "./Components/SingleProducts/SingleProducts";
import Quantity from "./Components/Quantity/Quantity";
import Reviews  from "./Components/Reviews/Reviews";
import OrderRecived  from "./Components/OrderRecived/OrderRecived";
import UserSetting  from "./Components/UserSetting/UserSetting";
import PaymentMethod  from "./Components/PaymentMethod/PaymentMethod";
import AddPayment  from "./Components/AddPayment/AddPayment";
import PaymentEmpty  from "./Components/PaymentEmpty/PaymentEmpty";
import OrdersHistory  from "./Components/OrdersHistory/OrdersHistory";
import AddShipping  from "./Components/AddShipping/AddShipping";
import Copyright  from "./Components/Copyright/Copyright";
import PopularProducts  from "./Components/PopularProducts/PopularProducts";
import TopRating  from "./Components/TopRating/TopRating";
import OrderEmpty  from "./Components/OrderEmpty/OrderEmpty";
import UserProfile  from "./Components/UserProfile/UserProfile";
import AddressEmpty  from "./Components/AddressEmpty/AddressEmpty";
import ReviewsRating  from "./Components/ReviewsRating/ReviewsRating";
import ProductItemGrid   from "./Components/ProductItemGrid/ProductItemGrid";
import ProductItem from "./Components/ProductItem/ProductItem";
import ListProducts  from "./Components/ListProducts/ListProducts";
import GridProducts from "./Components/GridProducts/GridProducts";
import ShopSort from "./Components/ShopSort/ShopSort";
import Terms from "./Components/Terms/Terms";
import Shop  from "./Components/Shop/Shop";
import Outfit  from "./Components/Outfit/Outfit";
import Outfits  from "./Components/Outfits/Outfits";



import { Switch, Route } from 'react-router-dom';

class App extends Component {
  render() {
    return (
      <div>
            <ExpandCategoris/>
           <HeaderTop/>
            <HeaderBottom/>
       <Switch>
       <Route path="/terms" component={Terms} />    
       <Route path="/shop" component={Shop} />   
       <Route path="/outfit" component={Outfit} />  
       <Route path="/outfits" component={Outfits} />    
  
       <Route path="/listproducts" component={ListProducts} />    
       <Route path="/reviewrating" component={ReviewsRating} />    
       <Route path="/AddressEmpty" component={AddressEmpty} />    
       <Route path="/userprofile" component={UserProfile} />    
       <Route path="/orderempty" component={OrderEmpty} />    
       <Route path="/addshipping" component={AddShipping} />    
       <Route path="/ordershistory" component={OrdersHistory} />    
       <Route path="/paymentempty" component={PaymentEmpty} />    
       <Route path="/Addpayment" component={AddPayment } />    
       <Route path="/Paymentmethod" component={PaymentMethod } />    
         <Route path="/usersetting" component={UserSetting } />    
           <Route path="/orderrecived" component={OrderRecived} />    
              <Route path="/reviews" component={Reviews} />    
                  <Route path="/cart" component={Cart} />    
                 <Route path="/checkout" component={Checkout} />
                <Route path="/EmailSent" component={EmailSent} />
                 <Route path="/ForgitPassword" component={ForgitPassword} />
                 <Route path="/Wishlistempty" component={WishlistEmpty} />
                 <Route path="/Cartempty" component={CartEmpty} />
                  <Route path="/Register" component={Register} />
                  <Route path="/Wishlist" component={Wishlist} />
                  <Route path="/GridProducts" component={GridProducts} />
                  <Route path="/singleshop" component={SingleProducts} />
                  <Route path="/Login" component={Login} />
                  <Route path="/" component={Home} />



</Switch>
       <Newsletter/>
         <Footer/>
         <Copyright/>
</div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js